<template>
  <span
    class="status-pill"
    :class="statusClass"
  >
    {{ status.toUpperCase() }}
  </span>
</template>

<script>
export default {
  name: 'StatusPill',

  props: {
    status: {
      type: String,
      default: 'paid'
    }
  },

  computed: {
    statusClass() {
      return this.status.toLowerCase() === 'paid'
        ? 'status-paid'
        : 'status-due';
    }
  }
};
</script>

<style scoped>
.status-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  border-radius: 50px;
  font-size: 12px;
  font-weight: 700;
}

.status-paid {
  background: #dceae4;
  color: #2cc8bc !important;
}

.status-due {
  background: #f3dddd;
  color: #d62828 !important;
}
</style>